import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import TransferList from "@/pages/transfer/List";

// 非首屏场景，开启路由懒加载
const TransferCreateService = lazy(
  () => import("@/pages/transfer/Create/Service"),
);

const TransferCreateRegion = lazy(
  () => import("@/pages/transfer/Create/Region"),
);
const TransferCreateStandard = lazy(
  () => import("@/pages/transfer/Create/Standard"),
);

// 审批
const TransferApprove = lazy(() => import("@/pages/transfer/Approve"));

// 详情
const TransferDetail = lazy(() => import("@/pages/transfer/Detail"));

// 发货
const TransferSend = lazy(() => import("@/pages/transfer/Send"));

// 收货
const TransferTake = lazy(() => import("@/pages/transfer/Take"));

const transferRoutes: RouteObject[] = [
  {
    path: "/transfer/list",
    element: <TransferList />,
  },
  {
    path: "/transfer/detail/:id",
    element: <TransferDetail />,
  },
  {
    path: "/transfer/create/region",
    element: <TransferCreateRegion />,
  },
  {
    path: "/transfer/create/service",
    element: <TransferCreateService />,
  },
  {
    path: "/transfer/create/standard",
    element: <TransferCreateStandard />,
  },
  {
    path: "/transfer/approve",
    element: <TransferApprove />,
  },
  {
    path: "/transfer/send",
    element: <TransferSend />,
  },
  {
    path: "/transfer/take",
    element: <TransferTake />,
  },
];

export default transferRoutes;
